import { render, staticRenderFns } from "./PcUpload.vue?vue&type=template&id=0f6f09b8&scoped=true"
import script from "./PcUpload.vue?vue&type=script&lang=js"
export * from "./PcUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f09b8",
  null
  
)

export default component.exports